import * as React from "react";
import {Dispatch, ReactNode, useReducer} from "react";

interface AppContextInterface {
    state: {
        darkMode: boolean;
    }
    dispatch: Dispatch<any>;
}

const initialState = {darkMode: false};
export const themeContext = React.createContext<AppContextInterface | null>(null);

const themeReducer = (state: any, action: any) => {
    switch (action.type) {
        case "toggle":
            return {darkMode: !state.darkMode};
        default:
            return state;
    }
};
export const ThemeProvider = (props: { children: ReactNode }) => {
    const [state, dispatch] = useReducer(themeReducer, initialState);
    return <themeContext.Provider value={{state, dispatch}}>{props.children}</themeContext.Provider>
};
